import { Component, ElementRef, HostListener, inject } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider'; 
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { AlertService } from 'app/core/services/alert.service';
import { AlertOptions } from 'app/core/data/interfaces/alert';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterLink, MatIconModule, MatDividerModule],
  templateUrl: './header.html',
  styleUrl: './header.scss'
})
export class HeaderComponent {
  private _alertService = inject(AlertService);
  private _authService = inject(AuthService);
  private _router = inject(Router);
  private _elementRef = inject(ElementRef);

  isMenuOpen = false;
  isMobileMenuOpen = false;

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    if (!this._elementRef.nativeElement.contains(event.target)) {
      this.closeMenu();
      this.closeMobileMenu();
    }
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    if (window.innerWidth > 768) {
      this.closeMobileMenu();
    }
  }

  get isLoggedIn(): boolean {
    return !!this._authService.accessToken;
  }

  get isOnLoginPage(): boolean {
    return this._router.url === '/login';
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu(): void {
    this.isMenuOpen = false;
  }

  toggleMobileMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  closeMobileMenu(): void {
    this.isMobileMenuOpen = false;
  }

  manageDetails(): void {
    this.closeMenu();
    this._router.navigate(['/account/manage']);
  }

  signOut(): void {
    this.closeMenu();
    this._authService.signOut().pipe(
      finalize(() => {
        const alertOptions: AlertOptions = {
          keepAfterRouteChange: true
        }
        this._alertService.success('You have been signed out successfully', alertOptions);
        localStorage.removeItem('token');
        this._router.navigate(['/']);
      })
    ).subscribe();
  }

  signIn(): void {
    this.closeMenu();
    this._router.navigate(['/login']);
  }

  viewReport(): void {
    this.closeMenu();
    this._router.navigate(['reports/results'])
  }
}
